import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { theme } from '../theme';
import './Navigation.css';

const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleCloseMenu = () => {
    setIsMenuOpen(false);
  };

  const navStyle = {
    backgroundColor: theme.colors.primary,
    padding: '0.75rem 1rem',
    color: theme.colors.background,
    width: '100%',
    position: 'sticky',
    top: 0,
    zIndex: 1000,
  };

  const navContentStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  };

  const linkStyle = {
    color: theme.colors.background,
    textDecoration: 'none',
    padding: '0.5rem 1rem',
    borderRadius: '4px',
    transition: 'background-color 0.3s',
    '&:hover': {
      backgroundColor: theme.colors.secondary,
    },
  };

  return (
    <nav style={navStyle}>
      <div style={navContentStyle}>
        <Link to="/" className="nav-logo">
          <img src="/logo-header.png" alt="Morales-Autrique Logo" />
          <span className="nav-brand">Morales-Autrique</span>
        </Link>
        <div className="nav-link-container">
          <Link to="/access" style={linkStyle}>Accesos</Link>
          <Link to="/guide" style={linkStyle}>Guía</Link>
          <Link to="/security" style={linkStyle}>Seguridad</Link>
          <Link to="/calendar" style={linkStyle}>Calendario</Link>
          <a 
            href="https://finanzas.moralesautrique.com/" 
            target="_blank" 
            rel="noopener noreferrer" 
            style={linkStyle}
          >
            Finanzas
          </a>
        </div>
        <button 
          className="menu-button"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`menu-icon ${isMenuOpen ? 'open' : ''}`}>
            <span></span>
            <span></span>
            <span></span>
          </span>
        </button>
      </div>
      <div className={`mobile-menu ${isMenuOpen ? 'open' : ''}`}>
        <Link to="/access" style={linkStyle} onClick={handleCloseMenu}>Accesos</Link>
        <Link to="/guide" style={linkStyle} onClick={handleCloseMenu}>Guía</Link>
        <Link to="/security" style={linkStyle} onClick={handleCloseMenu}>Seguridad</Link>
        <Link to="/calendar" style={linkStyle} onClick={handleCloseMenu}>Calendario</Link>
        <a 
          href="https://finanzas.moralesautrique.com/" 
          target="_blank" 
          rel="noopener noreferrer" 
          style={linkStyle}
          onClick={handleCloseMenu}
        >
          Finanzas
        </a>
      </div>
    </nav>
  );
};

export default Navigation; 